import {IFontFamily} from '../../architecture/sections/font-family.interface';

export function makeMrGreenFontsFamily(): IFontFamily {
    return {
        body: '"Montserrat", verdana, sans-serif',
        thin: '"Montserrat", verdana, sans-serif',
        light: '"Montserrat", verdana, sans-serif',
        regular: '"Montserrat", verdana, sans-serif',
        bold: '"Montserrat", verdana, sans-serif',
        medium: '"Montserrat", verdana, sans-serif',
        black: '"Montserrat", verdana, sans-serif',
        ultra: '"Montserrat", verdana, sans-serif',
        secondary: '"Oleo-Script-Bold", verdana, sans-serif',
    }
}